export default {
    getCourses: { method: 'get', url: 'courses' },
    getCoursesOfferedInWorkTime: { method: 'get', url: 'courses/offered-in-work-time' },
    postCourses: { method: 'post', url: 'courses' },
    updateCourses: { method: 'put', url: 'courses/{id}' },
    deleteCourses: { method: 'delete', url: 'courses/{id}' },
}